<template>
  <div>
    <h1>Error Page</h1>
  </div>
</template>
<script>
  export default {
    name: 'ErrorPage'
  }
</script>
<style lang=""></style>
